import { ReactNode } from 'react';
import { NodeContainer } from '@/GraphEditor/drawingLayer/nodeComposition/NodeContainer';
import { NodeContentStandardLayout } from '@/GraphEditor/drawingLayer/nodeComposition/NodeContentStandardLayout';
import { NodeInstance } from '@glueapp/graph-types';
import { InPortList } from '@/GraphEditor/drawingLayer/nodeComposition/InPortList';
import { OutPortList } from '@/GraphEditor/drawingLayer/nodeComposition/OutPortList';
import { InherentInPort, InherentOutPort } from './Ports';
import { useCurrentNode } from '@/GraphEditor/drawingLayer/contexts/CurrentNodeContext';
import { NodeBackground } from './NodeBackground';
import { IntegrationMarker } from '@/GraphEditor/drawingLayer/portOverlay/IntegrationMarker';
import { SpecialNodeMarker } from '@/GraphEditor/drawingLayer/portOverlay/SpecialNodeMarker';

interface Props {
    nodeInstance: NodeInstance;

    children?: ReactNode;
}

export const NodeStandardLayout: React.FC<Props> = ({ nodeInstance, children }) => {
    const node = useCurrentNode();
    return (
        <NodeContainer ariaLabel={node.name}>
            <NodeBackground color={node.color}>
                <NodeContentStandardLayout
                    name={node.name}
                    renderInPorts={() => <InPortList ports={nodeInstance.inPorts} />}
                    renderOutPorts={() => <OutPortList ports={nodeInstance.outPorts} />}
                    renderInherentInPort={() => <InherentInPort />}
                    renderInherentOutPort={() => <InherentOutPort />}
                    renderIntegrationMarker={node.integration ? () => <IntegrationMarker integration={node.integration!} /> : undefined}
                    renderSpecialMarker={() => <SpecialNodeMarker node={node} />}
                >
                    {children}
                </NodeContentStandardLayout>
            </NodeBackground>
        </NodeContainer>
    );
};
